import { Card, Inline, Stack, vars, Button } from '@etg/wings';
import { css } from '@eti/styles';
import { CaretRight } from '@phosphor-icons/react';
import type { ComponentProps, ReactNode } from 'react';
import { useDirection } from '@eti/providers';

const buttonStyles = css`
  text-decoration: none;
`;

const cardStyles = css`
  background-color: ${vars.colors.signal.information.tint};
`;

interface CardWithActionButtonProps extends ComponentProps<typeof Button> {
  children: ReactNode;
  buttonText: string;
  isRedirecting?: boolean;
}

const CardWithActionButton = ({
  children,
  buttonText,
  isRedirecting = true,
  ...buttonProps
}: CardWithActionButtonProps) => {
  const { isRTL } = useDirection();

  return (
    <Card className={cardStyles} data-testid="card-with-action-button">
      <Stack>
        {children}
        <Inline>
          <Button
            className={buttonStyles}
            data-testid="action-button"
            iconSuffix={
              (isRedirecting && <CaretRight aria-hidden="true" mirrored={isRTL} size={20} />) ||
              undefined
            }
            variant="primary"
            {...buttonProps}
          >
            {buttonText}
          </Button>
        </Inline>
      </Stack>
    </Card>
  );
};

export default CardWithActionButton;
